import { isNil } from 'ramda';

import { createTerm } from './createTerm';
import { IJsonQueryTerm } from '../../types/jsonQuery/term';

export function mergeTerm<T>({
  /* oxlint-disable-next-line typescript/no-unused-vars */
  jsonQueryPart,
  newJsonQueryPart,
}: {
  jsonQueryPart: IJsonQueryTerm<T>;
  newJsonQueryPart: IJsonQueryTerm<T>;
}) {
  const value = newJsonQueryPart?.value;

  if (isNil(value)) {
    return null;
  }

  return createTerm(value);
}
